export default __webpack_public_path__ + "static/media/closeBacktick.82ea75fc.svg";